<template>
        <div style="width: 100%">
            <ul id="selLang">
                <li class="list_elem" v-for="l in languages" :value="l.cod" @click="changeLanguage(l.description, l.cod)">
                    {{l.description}}
                    <span class="flag_icon" :style="{'background-image': 'url('+l.icon+')'}"></span>
                </li>
            </ul>
        </div>
</template>

<script>

import { eventBus } from "../../eventbus";

    export default {
        props: {
            source: Object
        },
        mounted: function(){
            var vm = this;
            console.log('Mounted with languages: ', this.source)
            var declLangs = Object.keys(vm.$root.front_end_configs.versions.jsonTranslations)
            var ltf = this.source.languages.filter((l)=>declLangs.includes(l.cod));
            this.languages = ltf;
        },
        created: function(){
            var vm = this;
            eventBus.$on("changeLangAlert",(paramLang)=>{ 
                vm.reloadApp(paramLang)
            })
        },
        data: function(){
            return {
                languages: [],
                selectedLang: 'it'
            }
        },
        methods: {
            changeLanguage: function (selectedLang, langCod) {
                var vm = this;
                console.log(selectedLang)
                localStorage.setItem("lang",langCod)
                
                eventBus.$emit('alert', {
                    message: vm.$Jed.firstUpperTranslate('application will be reloaded in %1$s...', null, {key: null, string: '<b>'+selectedLang+'</b>'}),
                    type: "info",
                    lang: langCod
                })
                
                eventBus.$emit('changeLangAlert', langCod);
            },
            reloadApp: function(lang){
                var currentURL = window.location.href;
                if(currentURL.includes("/detail/")){
                    var urlToSave = "originalUrl="+currentURL+"; max-age="+ (1000 * 60 * 3) +"; path=/; sameSite=strict"
                    document.cookie = urlToSave;
                }

                let codiceLingua;
                for(var i=0;i<this.languages.length; i++){
                    if(this.languages[i].cod==lang){
                        codiceLingua = this.languages[i].COD;
                        break;
                    }
                }

                //Imposto proprietà del cookie:
                //validità: 2 mesi
                //strict: transmit the cookie only to same site      
                
                document.cookie = "langCode="+codiceLingua+"; maxAge="+ (1000 * 60 * 60 * 24 * 60) +"; path=/; sameSite=strict";

                console.log(document.cookie)
                
                setTimeout(()=>{
                    //POSSO FARE IL REDIRECT DIRETTAMENTE ALL'URL PASSANDO LA LINGUA COME PARAMETRO
                    window.location.href = currentURL + '&lang=' + lang
                }, 2000);
            }
        }
    }
</script>
<style scoped>
    .notification-wrapper {
        height: auto;
        max-height: 400px;
        overflow-y: auto;
        margin-bottom: 0px;
        padding: 10px;
        padding-bottom: 0px;
    }
    
    #selLang{
        color: black!important;
        list-style: none; 
        padding: 0;
    }

    .list_elem {
        position: relative; 
        padding-left: 50px; 
        padding-top: 10px;
        padding-bottom: 10px;
        list-style: none; 
        display: flex;
        align-items: center;
        cursor: pointer; 
    }

    .list_elem:hover {
        background-color: #3c8dbc4d;
    }

    .flag_icon{
        width: 30px;
        height: 20px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        position: absolute;
        left: 0;
        margin-left: 10px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/others/ChooseLanguage.vue?472ac61c